import { Injectable } from '@angular/core';
import {VoipPeerApiService} from '../../../../services/api/network/online/voip-peer/voip-peer-api.service';
import {VoipPeersDialogService} from '../../../voip-peers/voip-peers-dialog/voip-peers-dialog.service';
import {MapService} from '../../map/map/map.service';

@Injectable({
  providedIn: 'root'
})
export class OnlineVoipPeerService {

  constructor(private voipPeerApiService: VoipPeerApiService,
              private voipPeersDialogService: VoipPeersDialogService,
              private mapService: MapService) {}

  public editVoipPeer(voipPeer): void {
    this.voipPeersDialogService.edit(voipPeer, () => {
      this.refreshDiagram();
    });
    /*Promise.all([this.voipPeerApiService.getVoipPeer(id),
      this.cacProfilesApiService.getCacProfiles().toPromise()
    ]).then(result => {
      const voipPeer = result[0];
      const cacProfiles = result[1].elements;

      this.sharedEventService.broadcast('openVoipPeerDialog', voipPeer, cacProfiles, () => {
        this.voipPeerApiService.editVoipPeer(voipPeer, id).then(() => {
          this.sharedEventService.broadcast('closeVoipPeerDialog');
          this.refreshDiagram();
        }).catch(() => {});
      });
    });*/
  }

  public addVoipPeer(voipPeer): void {
    this.voipPeersDialogService.add(voipPeer, () => {
      this.refreshDiagram();
    }, () => {
      this.removeDraggedSvg();
    });

    /*const voipPeerToAdd = _.cloneDeep(voipPeer);
    this.cacProfilesApiService.getCacProfiles().subscribe(cacProfiles => {
      this.sharedEventService.broadcast('openVoipPeerAddDialog', voipPeerToAdd, cacProfiles.elements, () => {
        this.voipPeerApiService.addVoipPeer(voipPeerToAdd).then(() => {
          this.sharedEventService.broadcast('closeVoipPeerAddDialog');
          this.refreshDiagram();
        }).catch(() => {});
      });
    });*/
  }

  public deleteVoipPeers(voipPeers): void {
    this.voipPeersDialogService.delete(voipPeers, () => {
      this.refreshDiagram();
    });
   /* this.sharedEventService.broadcast('openConfirmationDialogWindow',
      `Are you sure you want to delete ${voipPeers.length} peer connections: ${voipPeers.map(item => '"' + item.name + '" ')} ?`
      , 'Delete', () => {
        this.voipPeerApiService.deleteVoipPeers(voipPeers.map(item => item.id))
          .then(() => {
            this.sharedEventService.broadcast('closeConfirmationDialogWindow');
            this.refreshDiagram();
          }).catch(() => {
          this.sharedEventService.broadcast('closeConfirmationDialogWindow');
        });
      });*/
  }

  public deleteVoipPeer(voipPeer): void {
    this.voipPeersDialogService.delete([voipPeer], () => {
      this.refreshDiagram();
    });
    /*this.sharedEventService.broadcast('openConfirmationDialogWindow',
        `Are you sure you want to delete this VoIP Peer: "${voipPeer.name}" ?`, 'Delete', () => {
      this.voipPeerApiService.deleteVoipPeer(voipPeer.id)
        .then(() => {
          this.sharedEventService.broadcast('closeConfirmationDialogWindow');
          this.refreshDiagram();
        }).catch(() => {
        this.sharedEventService.broadcast('closeConfirmationDialogWindow');
      });
    });*/
  }

  private refreshDiagram(): void {
  /*  this.sharedEventService.broadcast('PeriodicRefresh');
    this.sharedEventService.broadcast('VoIPPeerTableRefresh');*/
    this.mapService.refresh();
    this.mapService.removeDraggedSvg();
  }

  private removeDraggedSvg(): void {
    this.mapService.removeDraggedSvg();
  }
}
